<div class="row">
  <div class="col col-12">
    <app-form-list-generator
      [SingleThreads]="true"
      [questionList]="questionList"
      [noCheckBox]="false"
      [viewList]="viewList"
      [translation]="translation"
      [productName]="productName"
      [Group]="formGroup"
    ></app-form-list-generator>
  </div>
</div>
